module.exports = __webpack_public_path__ + "img/house-flood.0ebae33f.svg";